import { FormFileUpload } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup } from 'reactstrap';
import { QuoteDiscountDocumentViewModel } from '../../QuoteDiscountDocumentViewModel';

export default class QuoteDiscountFormComponent extends React.Component {
  static propTypes = {
    quoteDiscount: PropTypes.object.isRequired,
    document: PropTypes.instanceOf(QuoteDiscountDocumentViewModel).isRequired,
    onDocumentUpdated: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  }

  updateQuoteDiscount = (updateObject) =>
    this.props.onDocumentUpdated(
      new QuoteDiscountDocumentViewModel({
        ...updateObject,
      })
    );

  render() {
    const { quoteDiscount, document } = this.props;
    return (
      <div>
        <FormGroup>
          <FormFileUpload
            hideUploadAfterFile={true}
            onFileUploaded={(fileInfo) =>
              this.updateQuoteDiscount({
                documentationFileKey: fileInfo.key,
                documentationFileName: fileInfo.name,
              })
            }
          >
            {document && document.documentationFileName}
          </FormFileUpload>
        </FormGroup>
      </div>
    );
  }
}
